/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AmendPaymentRequest,
  AmendPaymentResponse,
  ChangePaymentMethodResponse,
  PatchedChangePaymentMethodRequest,
  PatchedRescheduleScheduledPaymentRequest,
  RescheduleScheduledPaymentResponse,
  ScheduledPaymentDetail
} from '.././model';

import adminV1OrganizationsPaymentsScheduledPaymentsRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsScheduledPaymentsAmendCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsScheduledPaymentsChangeMethodPartialUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsScheduledPaymentsReschedulePartialUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsSubscriberMembershipsScheduledPaymentsRefundCreateMutator from '../../shared/services/axios-client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Return payment metadata + change history + transaction history.
 * @summary Payment detail with change history
 */
export const adminV1OrganizationsPaymentsScheduledPaymentsRetrieve = (
    organizationId: number,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsScheduledPaymentsRetrieveMutator<ScheduledPaymentDetail>>,) => {
      return adminV1OrganizationsPaymentsScheduledPaymentsRetrieveMutator<ScheduledPaymentDetail>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/scheduled-payments/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Change the amount on a scheduled payment, or waive it (sets amount to $0 and status to WAIVED). Captures actor, optional reason tag, and optional admin notes. Triggers a notification email to the family account holder after the transaction commits.
 * @summary Amend a scheduled payment (change amount or waive)
 */
export const adminV1OrganizationsPaymentsScheduledPaymentsAmendCreate = (
    organizationId: number,
    id: string,
    amendPaymentRequest: AmendPaymentRequest,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsScheduledPaymentsAmendCreateMutator<AmendPaymentResponse>>,) => {
      return adminV1OrganizationsPaymentsScheduledPaymentsAmendCreateMutator<AmendPaymentResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/scheduled-payments/${id}/amend/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: amendPaymentRequest
    },
      options);
    }
  /**
 * 
        Change the payment method for a scheduled payment. This updates the
        PaymentPlan's payment method, which applies to all future payments
        on the same plan.

        Only payments with status SCHEDULED, FAILED, or RETRY can be updated.
        Cash payments cannot have their method changed.
        
 * @summary Change payment method
 */
export const adminV1OrganizationsPaymentsScheduledPaymentsChangeMethodPartialUpdate = (
    organizationId: number,
    id: string,
    patchedChangePaymentMethodRequest: PatchedChangePaymentMethodRequest,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsScheduledPaymentsChangeMethodPartialUpdateMutator<ChangePaymentMethodResponse>>,) => {
      return adminV1OrganizationsPaymentsScheduledPaymentsChangeMethodPartialUpdateMutator<ChangePaymentMethodResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/scheduled-payments/${id}/change-method/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedChangePaymentMethodRequest
    },
      options);
    }
  /**
 * 
        Change the scheduled date of a payment. Only payments with status
        SCHEDULED can be rescheduled.

        If `apply_to_all_future` is true, the same date shift will be applied
        to every SCHEDULED payment on the same payment plan that falls on or
        after the rescheduled payment. Earlier payments are left unchanged.
        
 * @summary Reschedule a scheduled payment
 */
export const adminV1OrganizationsPaymentsScheduledPaymentsReschedulePartialUpdate = (
    organizationId: number,
    id: string,
    patchedRescheduleScheduledPaymentRequest: PatchedRescheduleScheduledPaymentRequest,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsScheduledPaymentsReschedulePartialUpdateMutator<RescheduleScheduledPaymentResponse>>,) => {
      return adminV1OrganizationsPaymentsScheduledPaymentsReschedulePartialUpdateMutator<RescheduleScheduledPaymentResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/scheduled-payments/${id}/reschedule/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedRescheduleScheduledPaymentRequest
    },
      options);
    }
  /**
 * Refund a scheduled payment
 * @summary Refund a scheduled payment
 */
export const adminV1OrganizationsPaymentsSubscriberMembershipsScheduledPaymentsRefundCreate = (
    organizationId: number,
    subPk: string,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsSubscriberMembershipsScheduledPaymentsRefundCreateMutator<void>>,) => {
      return adminV1OrganizationsPaymentsSubscriberMembershipsScheduledPaymentsRefundCreateMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/subscriber-memberships/${subPk}/scheduled_payments/${id}/refund/`, method: 'POST'
    },
      options);
    }
  export type AdminV1OrganizationsPaymentsScheduledPaymentsRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsScheduledPaymentsRetrieve>>>
export type AdminV1OrganizationsPaymentsScheduledPaymentsAmendCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsScheduledPaymentsAmendCreate>>>
export type AdminV1OrganizationsPaymentsScheduledPaymentsChangeMethodPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsScheduledPaymentsChangeMethodPartialUpdate>>>
export type AdminV1OrganizationsPaymentsScheduledPaymentsReschedulePartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsScheduledPaymentsReschedulePartialUpdate>>>
export type AdminV1OrganizationsPaymentsSubscriberMembershipsScheduledPaymentsRefundCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsSubscriberMembershipsScheduledPaymentsRefundCreate>>>
